import * as React from 'react';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { IDs } from '../../../helpers/IDs';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { lazyInject } from '../../../services/inversify';
import * as Moment from 'moment';
import DialogWrapper2 from '../../../core/dialog/dialog_wrapper_v2';
import { WMap } from '../map/Wmap';

export interface StandorteGebaeudeBestandProps {
    standortSelected: any;
}

export interface StandorteGebaeudeBestandState {
    rowForGps: any;
}

export class StandorteGebaeudeBestand extends React.Component<StandorteGebaeudeBestandProps, StandorteGebaeudeBestandState> {

    constructor(props: any) {
        super(props);
        this.state = {
            rowForGps: undefined
        };
        this.onFormChange = this.onFormChange.bind(this);
        this.preFilter = this.preFilter.bind(this);
    }
    @lazyInject(TriggerService) private triggerService: TriggerService;

    onFormChange(WFormData: any) {
        //  WFormData.setValue('datum', Moment().unix());
    }

    preFilter(data: Array<any>) {
        const { standortSelected } = this.props;
        return standortSelected
            ? data
                .filter((item: any) => (
                    item.standort_tid_orig
                    && +item.standort_tid_orig === standortSelected.tid
                ))
            : data;
    }

    render() {
        const { standortSelected } = this.props;
        const { rowForGps } = this.state;
        const customActions = [
            {
                label: 'GPS-Verortung',
                key: 'map_open',
                func: ((row: any) => {
                    let alertText = false;
                    if (!row.latitude && !row.longitude) {
                        if (standortSelected.latitude && standortSelected.longitude) {
                            row.latitude = standortSelected.latitude;
                            row.longitude = standortSelected.longitude;
                            row.checkGps = true;
                        } else {
                            alertText = true;
                        }
                    }

                    if (alertText) {
                        alert('Bitte zuerst den Standort verorten');
                    } else {
                        this.setState({
                            rowForGps: row,
                        });
                    }
                }),
                info: 'GPS-Verortung'
            }
        ];

        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_GEBAEUDE}
                    module={IDs.MOD_ETOOL}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    addLabel={'Gebäude erfassen'}
                    formPreset={{ standort_tid: standortSelected.tid }}
                    customActions={customActions}
                    customFormConfig={{
                        standort_tid: {
                            readonly: true
                        }
                    }}
                    onFormChange={this.onFormChange}
                    preFilterFunction={this.preFilter}
                    onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_GEBAEUDE)}
                />

                {rowForGps &&
                    <div>
                        <DialogWrapper2
                            onAfterClose={() => {
                                this.setState({
                                    rowForGps: undefined,
                                });
                            }}
                        >
                            <WMap
                                lat={this.state.rowForGps.latitude ? this.state.rowForGps.latitude : null}
                                long={this.state.rowForGps.longitude ? this.state.rowForGps.longitude : null}
                                data={this.state.rowForGps}
                                entity={IDs.ENT_GEBAEUDE}
                                edittable={true}
                                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_GEBAEUDE)}
                            />
                        </DialogWrapper2>
                    </div>
                }
            </div>
        );
    }
}
